import { Injectable } from '@angular/core';
import { Sysuser } from './Sysuser-angular';
import { SysuserServicePkg } from './sysuserPkg.service';



@Injectable({
  providedIn: 'root'
})
export class SysuserService extends SysuserServicePkg {
  constructor() {
    super();
    /*this.sqlSelect = 'SELECT SYSUser.*, ' +CR
      +' A.MA002 AS CUSTOM_NAME,B.MA002 AS VENDOR_NAME,C.MV002 AS WA013C,D.ME002 AS WA009C '+CR
      +'  FROM SYSUser '+CR
      +' LEFT JOIN $$COPMA AS A ON CUSTOMER=A.MA001 '+CR
      +' LEFT JOIN $$PURMA AS B ON VENDOR=B.MA001 '+CR
      +' LEFT JOIN $$CMSMV AS C ON C.MV001=WA013 '+CR
      +' LEFT JOIN $$CMSME AS D ON D.ME001=WA009 '+CR;*/
  }
  override async validateItem(item: any): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Sysuser): Promise<Sysuser> {
    await super.newRecord(newItem);
    return newItem;
  }


}
